module.exports = __webpack_public_path__ + "static/event_2-2169a9cdd40b7704b917a3b957bcaf49.png";